import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add token to requests
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Auth API
export const authAPI = {
  login: (credentials) => api.post('/auth/login', credentials),
  verifyToken: () => api.get('/auth/verify'),
  changePassword: (data) => api.put('/auth/change-password', data),
  getAdmins: () => api.get('/auth/admins'),
  addAdmin: (data) => api.post('/auth/admins', data),
  deleteAdmin: (id) => api.delete(`/auth/admins/${id}`),
};

// Stamps API
export const stampsAPI = {
  create: (stampData) => api.post('/stamps', stampData),
  getAll: (search = '') => api.get(`/stamps${search ? `?search=${search}` : ''}`),
  getById: (id) => api.get(`/stamps/${id}`),
  update: (id, stampData) => api.put(`/stamps/${id}`, stampData),
  delete: (id) => api.delete(`/stamps/${id}`),
  verify: (uid) => api.get(`/stamps/verify/${uid}`),
  bulkImport: (file) => {
    const formData = new FormData();
    formData.append('file', file);
    return api.post('/stamps/bulk-import', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },
};

export default api;
